import { Input, OnChanges, SimpleChanges } from '@angular/core';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BObjectModel } from '../../../../models';

@Component({
  selector: 'q-comp-cursus-edit',
  templateUrl: './cursus-edit.component.html',
  styleUrls: ['./cursus-edit.component.css']
})
export class CursusEditComponent implements OnChanges{

  constructor(
    private modalService: NgbModal,
  ) { }

  public boModel = new BObjectModel();
  @ViewChild('modal') modal: ElementRef;
  @Output() onModalClose = new EventEmitter<boolean>();

  public openModal(idCursus: string) {
    this.boModel = new BObjectModel();
    this.boModel.IdDonneeFils = idCursus;
    this.boModel.IdDonneePere = "1348";
    this.boModel.IdentBO = "BO_CYCLE";
    this.boModel.IdRelation = "REL_BO_CENT_BO_CYCLE";
    this.boModel.ShowSaveButton = true;
    this.boModel.ShowRemoveButton = false;
    this.modalService.open(this.modal, { size: 'q-xxl', centered: true, scrollable: true, windowClass: 'qmodalover' }).result.then((result) => {
    }, (reason) => {     
    });
  }

  ngOnChanges(changes: SimpleChanges) {
   // console.log(changes);
    // changes.prop contains the old and the new value...
  }
}
